// extracted by mini-css-extract-plugin
module.exports = {"link":"nav-item-module--link--21fV6","highlight":"nav-item-module--highlight--1um2U","navItem":"nav-item-module--navItem--2u65Z"};